import { NgModule } from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { Observable, throwError,Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';
import { ToastController } from '@ionic/angular';
import {StmgService} from '../state_Management/stmg.service'
import { map } from 'rxjs/operators';


import {CommonServiceService} from '../common_service/common-service.service'
import { LoginComponent } from 'src/app/modals/login/login.component';

@Injectable({
  providedIn: 'root'
})
export class AppInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    public alertController: AlertController,
    public toastController:ToastController,
    public modalController: ModalController,
    public stmg:StmgService,
    public common:CommonServiceService) { }

    is_alert:boolean=true;
    count=0;
    timer;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{

    //auto logout after 5min inactive
    this.stmg.is_logged_status.subscribe(isLogged=>{
      if(isLogged){
        clearTimeout(this.timer);
        this.timer= setTimeout(()=>{
          this.stmg.updateLoginStatus(false);
        },1000*60*15)
      }
    })
    

    // return next.handle(req).pipe(
    //   catchError(this.handleHttpError)
    // );
    
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //console.log('event--->>>', event);
          
        }
        return event;
      }),catchError((error: HttpErrorResponse) => {
        

        if (error.status === 0) {
          // console.log("alert " + this.is_alert);         
          // console.log("nisith errrr");
          let alert = new AlertComponent(this.alertController);
          alert.loginSuccessAlert("", "No Internet", "No internet connection");
        }

        if (error.status === 401) {
          this.stmg.updateLoginStatus(false);
          this.launchLogin();
          //this.timeOutAlert("", "Your Session Timeout", "Please log in agian");
        }
        
        return throwError(error);
      }));
    

  };


  async launchLogin() {
    const modal = await this.modalController.create({
      component: LoginComponent,
      cssClass: "customPopup",
    });
    return await modal.present();
  }

  

 

  handleHttpError(error : HttpErrorResponse){
    //console.log(error);
    if (error.status === 0) {
      //console.log("No internet erreor", error);
      //this.stmg.updateNetStatus(true);
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", "No Internet", "No internet connection");
      // alert("No internet connection");
      
    }
    
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        //console.log("login error 1234567: ", error)
        // this.router.navigate(['login']);
        // let alert = new AlertComponent(this.alertController);
        // alert.loginSuccessAlert("", "Service Error", "Login expired!! Please login");
      }

      
    }
    return throwError(error);
  }



  async timeOutAlert(Title, SubTitle, Message) {

    const alerttimeout = await this.alertController.create({
      header: Title,
      subHeader: SubTitle,
      message: Message,
      buttons: [
        {
          text: 'OK',
          role: 'Cancel',
          cssClass: 'secondary',
          handler: async (blah) => {
            //console.log('Confirm Cancel: blah');
            const modal = await this.modalController.create({
              component: LoginComponent,
              cssClass: 'customPopup'
            });
            return await modal.present();
          }
        }
      ]
    });

    await alerttimeout.present();
  }
  


}
